export const isValidUsername = (username: string) =>
  /^[A-Z0-9._ ]{3,16}$/i.test(username);

export const isValidUsernameFormat = (username: string) =>
  /^[A-Z0-9 _-]+$/i.test(username);
